import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';
import { List } from 'react-virtualized';
class IssuerBankFilter extends Component {
    state = {
        issuerBankList:[],
        issuerBankValue: '',
        isIssuerLoading: true
    };
    componentDidMount(){
        this.issuer_bank(this.props.start_date,this.props.end_date);
    }
    resetIssuerBankFilter(){
        this.setState({
            issuerBankValue: [],
        })
    }
    issuer_bank(){
        this.setState({
            issuerBankList:[],
            issuerBankValue: [],
            isIssuerLoading: true
        })
        axios.get(config.get('API_URL')+'/reports/get-issuing-banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            let issuerList = [];
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuBank, index) => {
                    issuerList.push({value: issuBank.issuing_bank_name, label: issuBank.issuing_bank_name})
                });
            }
            this.setState({
                isIssuerLoading: false,
                issuerBankList:issuerList
            })
        });

    }


    change_issuer(optionSelected){
        let value='';
        let issuArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                issuArray.push(mids.value)
                var index = this.state.issuerBankList.findIndex(obj => obj.value==mids.value);
                this.state.issuerBankList.move(index,0).join(',');
            });
        }
        this.props.onSelectIssuerBank(optionSelected, issuArray);
        this.setState({
            issuerBankValue:optionSelected,
        });
    }
    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        return (
            <ReactMultiSelectCheckboxes name="issuer"
                isMulti
                value={this.state.issuerBankValue}
                components={{ MenuList }}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.change_issuer.bind(this)}
                options={this.state.issuerBankList}
                placeholderButtonLabel="Select [issuer]"
                isLoading={this.state.isIssuerLoading}
            />
        );

    }
}
export default IssuerBankFilter;